import { render, staticRenderFns } from "./cascad-menu.vue?vue&type=template&id=012c4c67&scoped=true&"
import script from "./cascad-menu.vue?vue&type=script&lang=js&"
export * from "./cascad-menu.vue?vue&type=script&lang=js&"
import style0 from "./cascad-menu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cascad-menu.vue?vue&type=style&index=1&id=012c4c67&lang=scss&scoped=true&"
import style2 from "./cascad-menu.vue?vue&type=style&index=2&id=012c4c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012c4c67",
  null
  
)

export default component.exports